import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const ShootingSchedule = ApplicationRecord.extend({
  static: {
    jsonapiType: 'shooting_schedules',
  },
  attrs: {
    schoolId: attr(),
    appointmentsPerBlock: attr(),
    shootingDay: attr(),
    startTime: attr(),
    endTime: attr(),
    availableTimeslots: attr(),
    // Option-aware, span-checked start-times to OFFER (server is the single
    // source of truth). Requires filter[option_id] on the request.
    bookableTimeslots: attr(),
    school: belongsTo(),
  },
})

export default ShootingSchedule
